import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";
import { Button } from "@mui/material";
import { getIn } from "formik";

export function InputFile({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, handleBlur, handleChange }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  labelButton,
  selectedFile,
  ...props
}) {
  // console.log(
  //   field.name,
  //   Boolean(getIn(touched, field.name) && getIn(errors, field.name)),
  //   getIn(touched, field.name) && getIn(errors, field.name)
  // );
  return (
    <>
      <input
        id="file-upload"
        type="file"
        style={{ display: "none" }}
        name={field.name}
        label={label}
        onBlur={handleBlur}
        onChange={handleChange}
        {...field}
        {...props}
      />
      <label htmlFor="file-upload">
        {selectedFile && <p>File yang dipilih : {selectedFile.name}</p>}
        <Button
          variant="outlined"
          component="span"
          startIcon={<CloudUploadIcon />}
        >
          {labelButton}
        </Button>
      </label>
      <div>{getIn(touched, field.name) && getIn(errors, field.name)}</div>
    </>
  );
}
